import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokonkandarshancab() {



const cardData = {
  keyword: "Mumbai to Konkan Darshan Cab",
  heading: "Lotus Cab: Mumbai to Konkan Darshan Cab",

  headingDescription:
    "Lotus Cab provides reliable and comfortable Mumbai to Konkan Darshan cab services for families, pilgrims, weekend travelers, and corporate groups. The Konkan region is famous for its pristine beaches, ancient temples, coastal highways, and scenic hill routes, which require experienced drivers and well-maintained vehicles. We offer AC sedans, spacious SUVs, luxury vehicles, and mini buses for group travel, ensuring safe and relaxed long-distance journeys. Whether you need a one-way drop, round-trip package, multi-day Konkan tour, or same-day return plan, we provide flexible travel solutions with transparent per-kilometer pricing. Our professional chauffeurs are trained for coastal and ghat road driving, ensuring smooth and secure travel. With 24/7 booking assistance and punctual pickup across Mumbai, Lotus Cab guarantees a memorable and stress-free Konkan Darshan experience.",

  top: "Top Konkan Darshan Places to Visit from Mumbai",

  topPlaces: [
    {
      title: "Ganpatipule",
      description:
        "Ganpatipule is one of the most famous pilgrimage and beach destinations in Konkan. The Ganpati Temple located near the sea attracts thousands of devotees every year. The calm beach and scenic coastal beauty make it perfect for family trips. SUV and sedan options provide smooth highway travel. The peaceful environment offers spiritual and relaxing experience. Lotus Cab ensures safe and comfortable temple visits."
    },
    {
      title: "Ratnagiri",
      description:
        "Ratnagiri is known for its Alphonso mangoes, beaches, and historical forts. It offers a blend of cultural heritage and coastal charm. Families enjoy the serene beaches and local Konkan cuisine. The highway journey is scenic and refreshing. AC cab travel ensures comfortable long-distance driving. Lotus Cab provides flexible multi-day tour packages."
    },
    {
      title: "Tarkarli",
      description:
        "Tarkarli is famous for its crystal-clear waters and water sports activities. It is a popular destination for beach lovers and adventure enthusiasts. The calm surroundings make it ideal for weekend relaxation. SUV vehicles are recommended for group travel. Comfortable travel enhances the coastal experience. Lotus Cab offers round-trip and extended stay options."
    },
    {
      title: "Malvan",
      description:
        "Malvan is a coastal town known for Sindhudurg Fort and authentic Malvani cuisine. The historical fort attracts heritage lovers and photographers. The scenic coastal drive makes the journey enjoyable. Ideal for family and group tours. Lotus Cab ensures safe and smooth transportation."
    },
    {
      title: "Harihareshwar",
      description:
        "Harihareshwar is a peaceful beach town known for its temple and scenic coastline. It offers a calm spiritual environment. Couples and families prefer it for weekend retreats. Comfortable AC vehicles enhance the journey. Lotus Cab provides convenient return packages."
    },
    {
      title: "Dapoli",
      description:
        "Dapoli is known for its clean beaches and dolphin sightings. It is a hidden gem of Konkan. Ideal for nature lovers and picnic trips. The road journey offers beautiful views. SUV cabs ensure safe and comfortable travel. Lotus Cab offers customized travel plans."
    }
  ],

  services: [
    {
      name: "Mumbai to Konkan Darshan Cab",
      description:
        "Lotus Cab provides reliable Mumbai to Konkan Darshan taxi service with flexible travel packages. AC sedans and SUVs ensure comfortable long-distance journeys. Professional drivers are experienced in coastal and ghat road travel. Ideal for pilgrimage tours and beach vacations. Transparent per-kilometer pricing maintained. 24/7 booking support available."
    },
    {
      name: "Mumbai to Konkan AC Cab",
      description:
        "Fully air-conditioned vehicles available for comfortable travel across Konkan routes. Suitable for long highway drives. Clean and sanitized interiors maintained regularly. Ideal for summer coastal travel. Affordable pricing available. Flexible travel options provided."
    },
    {
      name: "SUV Cab Mumbai to Konkan",
      description:
        "Spacious SUV vehicles perfect for family and group travel. Extra luggage space for extended tours. Stable performance on coastal roads. Safe hill and highway driving ensured. Ideal for multi-day trips. Comfortable AC seating provided."
    },
    {
      name: "Luxury Cab Mumbai to Konkan",
      description:
        "Premium luxury vehicles available for comfortable and stylish travel. Ideal for corporate guests and honeymoon couples. Smooth and quiet ride quality ensured. Professional chauffeur-driven service included. Customized travel plans available."
    },
    {
      name: "One Way Cab Mumbai to Konkan",
      description:
        "Affordable one-way drop service available for Konkan destinations. Pay only for one-side distance. Ideal for relocation or planned return by train/flight. Transparent billing policy maintained. Safe and comfortable travel guaranteed."
    },
    {
      name: "Round Trip Cab Mumbai to Konkan",
      description:
        "Flexible round-trip packages available for weekend and multi-day travel. Return schedule customizable as per plan. AC vehicles ensure comfort. Transparent fare structure shared before booking. Professional support throughout journey."
    }
  ],

  tableData: [
    ["Mumbai to Konkan Darshan Cab", "Mumbai to Konkan AC Cab"],
    ["Sedan Cab Mumbai to Konkan", "SUV Cab Mumbai to Konkan"],
    ["Luxury Cab Mumbai to Konkan", "Online Booking Cab Mumbai to Konkan"],
    ["Family Trip Cab Mumbai to Konkan", "Corporate Cab Mumbai to Konkan"],
    ["One Way Cab Mumbai to Konkan", "Round Trip Cab Mumbai to Konkan"],
    ["Weekend Trip Cab Mumbai to Konkan", "Mini Bus Cab Mumbai to Konkan"],
    ["Chauffeur Driven Cab Mumbai to Konkan", "Per Km Rate Mumbai to Konkan"],
    ["Picnic Tour Cab Mumbai to Konkan", "Outstation Cab Service Mumbai to Konkan"],
    ["Same Day Return Cab Mumbai to Konkan", "Budget Cab Mumbai to Konkan"],
    ["Best Cab Mumbai to Konkan", "Group Travel Cab Mumbai to Konkan"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Experienced Coastal Drivers",
      WhyChoosedescription:
        "Drivers are trained for coastal highways and ghat roads. Safe navigation ensured. Professional long-distance experience provided."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear and upfront fare breakdown shared before booking confirmation. No hidden charges."
    },
    {
      WhyChooseheading: "Wide Fleet Options",
      WhyChoosedescription:
        "Sedan, SUV, luxury, and mini bus options available for all travel needs."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Round-the-clock booking and customer support available."
    },
    {
      WhyChooseheading: "Family & Corporate Friendly",
      WhyChoosedescription:
        "Packages suitable for family vacations and corporate group tours."
    },
    {
      WhyChooseheading: "Clean & Sanitized Vehicles",
      WhyChoosedescription:
        "Vehicles regularly cleaned and maintained for hygiene and safety."
    },
    {
      WhyChooseheading: "Flexible Travel Packages",
      WhyChoosedescription:
        "One-way, round-trip, and multi-day tour options available."
    },
    {
      WhyChooseheading: "Reliable Customer Support",
      WhyChoosedescription:
        "Dedicated assistance provided throughout your Konkan journey."
    }
  ]
};

const faqData = [
  { question: "Do you provide multi-day Konkan tour packages?", answer: "Yes, flexible multi-day Konkan Darshan packages available with customized itinerary and transparent pricing." },
  { question: "Is SUV recommended for Konkan travel?", answer: "SUV is recommended for comfortable coastal and ghat road travel, especially for family trips." },
  { question: "Is one-way drop available?", answer: "Yes, affordable one-way drop service available for Konkan destinations." },
  { question: "Are luxury vehicles available?", answer: "Yes, premium luxury vehicles available for corporate and VIP travel." },
  { question: "Is same-day return possible?", answer: "Yes, same-day return packages available depending on destination distance." },
  { question: "Are vehicles AC?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Is corporate booking supported?", answer: "Yes, invoice billing and corporate packages available." },
  { question: "Is online booking available?", answer: "Yes, instant online booking confirmation provided." },
  { question: "Is pricing per km transparent?", answer: "Yes, complete fare breakdown shared before booking." },
  { question: "Is group travel available?", answer: "Yes, mini bus and SUV options available for group tours." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Mehta",
    feedback:
      "Booked Mumbai to Konkan Darshan cab for family trip. Very smooth journey and professional driver. Highly recommended.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Shah",
    feedback:
      "SUV was spacious and clean. Coastal drive was comfortable and safe. Excellent service.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Used luxury cab option for business guest travel. Very punctual and reliable service.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Rahul Patil",
    feedback:
      "Transparent pricing and flexible return options made our Konkan tour stress-free.",
    rating: 5
  }
];






























































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Konkan Darshan Cab",
  "image": "https://lotuscab.com/assets/images/mumbai-to-konkan-darshan-cab.jpg", 
  "description": "Lotus Cab provides Mumbai to Konkan Darshan cab services with AC, sedan, SUV, luxury cabs, and Mini Bus options. Perfect for one-way trips, round trips, family tours, corporate travel, weekend getaways, group trips, picnic tours, and same-day returns. Book online for chauffeur-driven cabs at competitive per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/mumbai-to-konkan-darshan-cab"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Mumbai to Konkan Darshan Cab | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Konkan Darshan cab with Lotus Cab. AC, sedan, SUV, luxury cabs & Mini Bus for one-way, round trips, family, corporate, weekend, group & picnic travel. Online booking available. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Konkan Darshan Cab, Mumbai to Konkan AC Cab, Sedan Cab Mumbai to Konkan, SUV Cab Mumbai to Konkan, Luxury Cab Mumbai to Konkan, Online Booking Cab Mumbai to Konkan, Family Trip Cab Mumbai to Konkan, Corporate Cab Mumbai to Konkan, One Way Cab Mumbai to Konkan, Round Trip Cab Mumbai to Konkan, Weekend Trip Cab Mumbai to Konkan, Mini Bus Cab Mumbai to Konkan, Chauffeur Driven Cab Mumbai to Konkan, Per Km Rate Mumbai to Konkan, Picnic Tour Cab Mumbai to Konkan, Outstation Cab Service Mumbai to Konkan, Same Day Return Cab Mumbai to Konkan, Budget Cab Mumbai to Konkan, Best Cab Mumbai to Konkan, Group Travel Cab Mumbai to Konkan" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokonkandarshancab;